import React from 'react'
import { Text } from "@chakra-ui/react"

function FooterSubOptionsText({ text }) {
    return (
        <>
            <Text fontSize='xs'>{text}</Text>
        </>
    )
}

export default FooterSubOptionsText